import React, { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { NavLink, useNavigate } from "react-router-dom";

function DropDown({ toggle, setToggle, ulRef }) {
  const [search, setSearch] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    if (toggle) {
      ulRef.current.style.height = "80vh";
    } else {
      ulRef.current.style.height = "0";
    }
  }, [toggle]);
  const handleSearch = (e) => {
    e.preventDefault();
    navigate("/search/" + search);
  };
  return (
    <div className="drop-down" ref={ulRef}>
      <br />
      <form
        className="search"
        style={{ width: "90%", height: "35px", display: "flex" }}
        onSubmit={(e) => handleSearch(e)}
      >
        <input
          type="text"
          placeholder="Search for book"
          onChange={(e) => setSearch(e.target.value)}
        />
        <button>
          <BiSearch size={20} />
        </button>
      </form>
      <NavLink
        to={"/"}
        style={({ isActive }) => ({
          color: "black",
          textDecoration: "none",
          width: "90%",
        })}
      >
        <li>Home</li>
      </NavLink>
      <NavLink
        to={"/product/all"}
        style={({ isActive }) => ({
          color: "black",
          textDecoration: "none",
          width: "90%",
        })}
      >
        <li>Products</li>
      </NavLink>
      <NavLink
        to={"/about"}
        style={({ isActive }) => ({
          color: "black",
          textDecoration: "none",
          width: "90%",
        })}
      >
        <li>About</li>
      </NavLink>
      {/*<NavLink
        to={"/cart"}
        style={({ isActive }) => ({
          color: "black",
          textDecoration: "none",
          width: "90%",
        })}
      >
        <li>Cart</li>
      </NavLink>
      <br />
      <button
        className="btn"
        style={{ width: "90%" }}
        onClick={() => navigate("/login")}
      >
        Login
      </button>*/}
    </div>
  );
}

export default DropDown;
